export const TRANSMISSION_OPTIONS = [
  {
    key: "Auto",
    value: "Auto",
  },
  {
    key: "Manual",
    value: "Manual",
  },
];

export const FUEL_OPTIONS = [
  {
    key: "Petrol",
    value: "Petrol",
  },
  {
    key: "Diesel",
    value: "Diesel",
  },
  {
    key: "Hybrid",
    value: "Hybrid",
  },
  {
    key: "Electric",
    value: "Electric",
  },
  {
    key: "CNG",
    value: "CNG",
  },
  {
    key: "Other",
    value: "Other",
  },
];
